<template>
  <div>
    <GSDescription
      class="reward-description"
      :imgUrl="rewardImg"
      :text="getBindPhoneDescription()"
    ></GSDescription>
    <div class="bind-input">
      <GSDropDownInput
        v-if="bindPhone"
        :dropdownPlaceholder="$t('lbl__select_country_region')"
        :dropdownItems="countryCodeList"
        :inputPlaceholder="$t('lbl__input_phone_number')"
        :inputDigitOnly="true"
        inputType="tel"
        @changed="updatePhoneNumber"
      ></GSDropDownInput>
      <GSInput
        v-if="bindEmail"
        :placeholder="$t('lbl__input_email')"
        @changed="updateEmailAddress"
      ></GSInput>
    </div>
    <GSRecaptcha
      class="recaptcha-widget"
      :onVerify="onVerifyRecaptcha"
      :language="recaptchaLanguage"
      ref="gsrecaptcha"
    ></GSRecaptcha>
    <GSButton
      :text="$t('btn__submit')"
      class="submit-button"
      @clicked="submit"
    ></GSButton>
    <GSAgreement
      :text="$t('lbl__user_agreement_{privacy_policy}')"
      :privacyPolicy="$t('lbl__privacy_policy')"
      @clicked="showPolicyPopup"
    ></GSAgreement>
  </div>
</template>

<script>
import GSDescription from '@/components/GSDescription'
import GSDropDownInput from '@/components/GSDropDownInput'
import GSInput from '@/components/GSInput'
import GSButton from '@/components/GSButton'
import GSAgreement from '@/components/GSAgreement'
import GSRecaptcha from '@/components/GSRecaptcha'

import BindBaseMixin from './mixins/BindBaseMixin'
import { EVENT } from '@/constants/event'
import { COUNTRY_TO_RECAPTCHA_LANG, DEFAULT_LOCALE } from '@/constants'

export default {
  name: 'BindPage',
  mixins: [BindBaseMixin],
  data () {
    return {
      rewardImg: ''
    }
  },
  created () {
    // check existing binding
    this.request('get',
      this.getApiUrl('query'), {
        access_token: this.$store.getters['bind/requestParams'].access_token,
        ...this.getServerRoleClientParams()
      }, (data) => {
        if (this.bindPhone && data['phone']) {
          this.$store.dispatch('bind/setPhoneNumber', data['phone'])
          this.redirectToBindStep('success')
        } else if (this.bindEmail && data['email']) {
          this.$store.commit('bind/updateEmail', {
            email: data['email']
          })
          this.redirectToBindStep('success')
        }
      }, (errMsg) => {})
    // get reward info
    this.request('get',
      this.getApiUrl('reward_info'), {
        access_token: this.$store.getters['bind/requestParams'].access_token
      }, (data) => {
        let key = this.bindPhone ? 'phone' : 'email'
        if (key in data && data[key].status === 1) {
          this.rewardImg = data[key]['img_url']
        }
      })
  },
  methods: {
    getBindPhoneDescription () {
      return this.bindPhone ? this.$t('lbl__bind_phone_number_description')
        : this.$t('lbl__bind_email_description')
    },
    showPolicyPopup () {
      this.$emit(EVENT.SHOW_POLICY)
    },
    submit () {
      this.bindPhone ? this.submitBindPhoneInit() : this.submitBindEmailInit()
      this.$refs.gsrecaptcha.resetRecaptcha()
    },
    onVerifyRecaptcha (response) {
      this.captchaToken = response
    }
  },
  computed: {
    recaptchaLanguage () {
      return COUNTRY_TO_RECAPTCHA_LANG[(this.$store.getters['bind/requestParams'].locale || DEFAULT_LOCALE).slice(-2)]
    }
  },
  components: {
    GSDescription,
    GSDropDownInput,
    GSInput,
    GSButton,
    GSAgreement,
    GSRecaptcha
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/vars/base';

.reward-description {
  margin-top: $base-size * 60;
}

.bind-input {
  margin-top: $base-size * 50;
}

.submit-button {
  margin-top: $base-size * 20;
}

.recaptcha-widget {
  width: max-content;
  margin: auto;
  margin-top: $base-size * 20;
}
</style>



// WEBPACK FOOTER //
// src/pages/bind/BindPage.vue